import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import VueI18n from 'vue-i18n';
import es from 'vuetify/lib/locale/es';

Vue.use(Vuetify)
Vue.use(VueI18n)
const i18n = new VueI18n({
    locale: 'en', // set locale
    messages, // set locale messages
})


// Ready translated locale messages
const messages = {
    en: {
        $vuetify: {
            dataTable: {
                itemsPerPageText: 'Items per page:'
            },
            dataIterator: {
                pageText: '{0}-{1} of {2}'
            }
        }
    },
    sv: {
        $vuetify: {
            dataTable: {
                itemsPerPageText: 'Element per sida:'
            },
            dataIterator: {
                pageText: '{0}-{1} av {2}'
            }
        }
    }
}


export default new Vuetify({
    lang: {
        locales: {
            es
        },

    },
});